import * as api from '../apis/auth';
import { apiCall } from '~/lib/redux/api';
import { EntityActions, AuthActions } from './consts';
import { UserNormalizer, UserAuthNormalizer } from './normalize';

export function login(username: string, password: string) {
  return apiCall({
    actions: [
      AuthActions.LOGIN_REQUEST,
      [EntityActions.ADD_ENTITIES, AuthActions.LOGIN_SUCCESS],
      AuthActions.LOGIN_ERROR
    ],
    normalizer: UserAuthNormalizer,
    fn: () => api.login(username, password),
  });
}

export function checkAuth(token) {
  return apiCall({
    actions: [
      AuthActions.LOGIN_REQUEST,
      [EntityActions.ADD_ENTITIES, AuthActions.LOGIN_SUCCESS],
      AuthActions.LOGIN_ERROR
    ],
    normalizer: UserNormalizer,
    fn: () => api.checkAuth(token),
    then: (data) => {
      // Convert the response to a login-type response
      return {
        entities: data.entities,
        result: {
          token,
          user: data.result,
        }
      };
    }
  });
}

// the purpose of this action is to refresh auth.currentUser info
// checkAuth doesn't fit this need
//  beacuse AuthActions.LOGIN_REQUEST action sets currentUser to null
export function vaidateAuth(token) {
  return apiCall({
    actions: [
      AuthActions.VALIDATE_REQUEST,
      [EntityActions.ADD_ENTITIES, AuthActions.LOGIN_SUCCESS],
      AuthActions.LOGIN_ERROR
    ],
    normalizer: UserNormalizer,
    fn: () => api.checkAuth(token),
    then: (data) => {
      // Convert the response to a login-type response
      return {
        entities: data.entities,
        result: {
          token,
          user: data.result,
        }
      };
    }
  });
}

export function forcePasswordChange(username: string, password: string, newPassword: string, acceptTerms: boolean) {
  return apiCall({
    actions: [
      AuthActions.LOGIN_REQUEST,
      [EntityActions.ADD_ENTITIES, AuthActions.LOGIN_SUCCESS],
      AuthActions.LOGIN_ERROR,
    ],
    normalizer: UserAuthNormalizer,
    fn: () => api.forcePasswordChange(username, password, newPassword, acceptTerms),
  });
}

export function logout() {
  return apiCall({
    actions: [
      AuthActions.LOGOUT_REQUEST,
      AuthActions.LOGOUT_SUCCESS,
      AuthActions.LOGOUT_ERROR
    ],
    fn: () => api.logout(),
  });
}

